import { render, staticRenderFns } from "./FiltroAdicional.vue?vue&type=template&id=2212ea53"
import script from "./FiltroAdicional.vue?vue&type=script&lang=js"
export * from "./FiltroAdicional.vue?vue&type=script&lang=js"
import style0 from "./FiltroAdicional.vue?vue&type=style&index=0&id=2212ea53&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports